import { connect } from "react-redux";
import { compose } from "recompose";
import TimerRemote from "./TimerRemote";
import {
  displayOpen,
  displayClose,
  remoteClose,
  selectPaired,
  selectDisplayOn,
  RealtimeState,
} from "src/pods/realtime";
import { TimerSlice, selectTime, sendTime } from "src/pods/timer";
import withRouteParams from "src/shared/hoc/withRouteParams";

type TimerRemoteContainerState = {
  paired: boolean;
  displayOn: boolean;
};

const mapStateToProps = (state: TimerRemoteContainerState & RealtimeState & TimerSlice) => ({
  time: selectTime(state),
  isCasting: selectDisplayOn(state),
  isConnected: selectPaired(state),
});

const mapDispatchToProps = { sendTime, displayOpen, displayClose, remoteClose };

export default compose(
  withRouteParams(["classId", "mountPoint"]),
  connect(mapStateToProps, mapDispatchToProps),
)(TimerRemote);
